import React from "react";
import "./Faq.scss";
import Footer from "../common/Footer/NewFooter";
import Header from "../common/Header/Header";
import FAQIMG from "../../assets/images/mains/shopifyFAQ.svg";

const ShopifyFAQ = () => {
  return (
    <div id='faq'>
      <Header />
      <FAQ />
      <FAQITEMS />
      <Footer />
    </div>
  );
};

export default ShopifyFAQ;

export const FAQ = () => {
  return (
    <div className="hero-container custom-hero-container container-sm mb-5">
      <div className=" hero-row custom-hero-row row m-0 w-100 h-100">
        <div className="col-12 col-sm-6 heroText-container flex">
          <div className="heroTitle w-100 mt-5">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="heroDesc w-100 my-4">
            <p>Predicting buying intent in the post cookie world.</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 mt-5 mt-sm-0">
          <div className="hero-img-container">
            <img className="img-fluid faq-img" src={FAQIMG} alt="FAQ" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const FAQITEMS = () => {
  return (
    <div className="container mt-5 mb-5 pt-5">
      <h3>PRODUCT & USAGE</h3>
      <br />
      <div>
        <input type="checkbox" id="question1" name="q" class="questions" />
        <div class="plus">+</div>
        <label for="question1" class="question">
          How will I receive account credentials?
        </label>
        <div class="answers">
          <p>
            {" "}
            You can see your account credentials when you click the Settings tab
            in the dashboard sidebar. Our{" "}
            <a href="https://www.youtube.com/watch?v=no5OHP5jwyQ">
              CausalFunnel Dashboard Demo
            </a>{" "}
            has more details.
          </p>
        </div>
      </div>
      <div>
        <input type="checkbox" id="question2" name="q" class="questions" />
        <div class="plus">+</div>
        <label for="question2" class="question">
          How can I view my company dashboard?
        </label>
        <div class="answers">
          <p>
            If you are a shopify customer then you can see your dashboard by
            clicking the CausalFunnel app icon in your stores app section. See
            more here:{" "}
            <a href="https://www.youtube.com/watch?v=no5OHP5jwyQ">
              CausalFunnel Dashboard Demo
            </a>
            . For non-Shopify customers, you can view your company dashboard by
            clicking here:
            <a href="https://www.causalfunnel.com/dashboard"> view dashbaord</a>
          </p>
        </div>
      </div>
      <div>
        <input type="checkbox" id="question3" name="q" class="questions" />
        <div class="plus">+</div>
        <label for="question3" class="question">
          How can I contact the team?
        </label>
        <div class="answers">
          <p>You can email your queries at hi@causalfunnel.com</p>
        </div>
      </div>
    </div>
  );
};
